export default __webpack_public_path__ + "static/media/not-partner.0a0eb93e.svg";